"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postAllAvailability = void 0;

var _availabilityAPI = require("MeetingsLib/api/availabilityAPI");

var postAllAvailability = function postAllAvailability(data) {
  return function (dispatch, getState, httpClient) {
    return (0, _availabilityAPI.postAllAvailability)(httpClient, data);
  };
};

exports.postAllAvailability = postAllAvailability;